import React, { useState, useEffect, useContext } from 'react';
import { Button, Row, Col } from 'react-bootstrap';
import { IcoEdit } from '@icons';
import ProjectModal from '@components/projects/ProjectModal';
import { useParams } from 'react-router-dom';
import BreadcrumbsNav from 'components/nav/breadcrumbsNav';
import { submenuTitleMap, tabDescriptionMap, tabTitleMap, tabTitleMapGuestEnteErogante } from 'utils/pageTitleMaps';
import { UserContext } from 'components/contexts/UserProvider';
import { OETrans } from 'components/translation/OETrans';
import EditModal from '@components/projects/EnteEroganteProjectsList/EditModal';

const ProjectHeader = ({ project, setProject, isProjectManager, fetchDataProject, navigationMenu, secondColumnContent, permissions }) => {
	const {
		userAccess: { isGuestEnteErogante },
	} = useContext(UserContext);
	const [thisProject, setThisProject] = useState({});
	const [showModalProject, setShowModalProject] = useState(false);
	const { tab, submenu } = useParams();

	const handleShowModal = (setShowModal) => setShowModal(true);

	useEffect(() => {
		if (project) {
			setThisProject(project);
		}
	}, [project]);

	const headerDescription = {
		fallback: tabDescriptionMap?.[tab]?.[submenu] ?? tabDescriptionMap[tab] ?? '',
		code: `headerdescriptions.${tab}` + (tabDescriptionMap?.[tab]?.[submenu] ? `.${submenu}` : ''),
	};

	const selectedTitleMap = isGuestEnteErogante ? tabTitleMapGuestEnteErogante : tabTitleMap;

	return (
		<>
			<Row className="my-4">
				<Col className="custom-project-header">
					<BreadcrumbsNav />

					<div className="d-flex flex-column mb-4">
						<h1 className="mb-0 fw-bold">{thisProject.name}</h1>

						<div className="d-inline-flex align-items-center flex-wrap mt-1 custom-project-details">
							<span className="p-0 project-details no-pipe">
								{thisProject.cupType === 'I' ? 'ID Progetto: ' : 'CUP: '}
								<span style={{ wordBreak: 'break-all' }}>{thisProject.cup}</span>

								<span className="d-inline-block ms-2">
									{permissions.canEditProject &&
										(isGuestEnteErogante ? (
											<EditModal
												trigger={
													<Button variant="link" className="p-0 d-flex align-items-center" style={{ lineHeight: 1 }}>
														<IcoEdit title={'Modifica Anagrafica'} className="edit" style={{ width: '1rem', height: '1rem' }} />
													</Button>
												}
												type="edit"
												project={thisProject}
												permissions={permissions}
											/>
										) : (
											<Button
												variant="link"
												onClick={() => handleShowModal(setShowModalProject)}
												className="p-0 d-flex align-items-center"
												style={{ lineHeight: 1 }}
											>
												<IcoEdit title={'Modifica Anagrafica'} className="edit" style={{ width: '1rem', height: '1rem' }} />
											</Button>
										))}
								</span>
							</span>
						</div>
					</div>

					{navigationMenu}

					{tab && (
						<div
							className="d-flex"
							style={{
								marginTop: '3rem',
							}}
						>
							<Col>
								<Row>
									<Col>
										<h2 className="mb-2" style={{ fontWeight: 'bold' }}>
											{selectedTitleMap[tab] || ''} {submenuTitleMap[submenu] || ''}
										</h2>
									</Col>
									{secondColumnContent && <Col className="pe-0 col-auto ms-auto">{secondColumnContent}</Col>}
								</Row>

								<h2 style={{ marginBottom: 0, fontSize: '18px', textTransform: 'none', fontWeight: 400, color: '#4A5968' }}>
									<OETrans code={headerDescription.code} fallback={headerDescription.fallback} />
								</h2>
							</Col>
						</div>
					)}
				</Col>
			</Row>

			{/* EDIT PROJECT */}
			{
				<ProjectModal
					showModalProject={showModalProject}
					setShowModalProject={setShowModalProject}
					project={thisProject}
					setProjectHeader={setProject}
					fetchDataProject={fetchDataProject}
					permissions={permissions}
				/>
			}
		</>
	);
};
export default ProjectHeader;
